import jsonExport from "jsonexport/dist";
import { downloadCSV } from "react-admin";

// Exportação CSV com cabeçalhos em português e só as colunas que fazem
// sentido para quem usa a tela. O exportador padrão do react-admin
// despeja os campos crus da API, em inglês — e, quando o registro traz
// objetos aninhados (ex.: sócios de um cargo), o cadastro inteiro deles.
export type CsvColumns = Record<string, (record: any) => unknown>;

export const toCsvRows = (records: any[], columns: CsvColumns) =>
  records.map((record) => {
    const row: Record<string, unknown> = {};
    Object.entries(columns).forEach(([header, value]) => {
      const v = value(record);
      row[header] = v === null || v === undefined ? "" : v;
    });
    return row;
  });

export const downloadCsvRows = (rows: Record<string, unknown>[], filename: string) =>
  jsonExport(rows, (err: any, csv: string) => {
    if (err) {
      console.error(err);
      return;
    }
    downloadCSV(csv, filename);
  });

// Exportador pronto para <List exporter={...}> de telas simples
export const csvExporter =
  (filename: string, columns: CsvColumns) => (records: any[]) =>
    downloadCsvRows(toCsvRows(records, columns), filename);

export const simNao = (value: unknown) => (value ? "Sim" : "Não");
